// src/client/renderer/vfx/items/skillshot-shared.ts
//
// Shared helpers for skillshot beam VFX pools (thunder-fist, frost-blaster, …).
//
// Audio:
//   Skillshot resolvers may emit cast, impact, and miss visuals; the item VFX
//   manager gates audio to phase='cast' so impact/miss beams do not replay it.

import * as THREE from 'three';

/**
 * Dispose all GPU resources (geometry + materials) in a THREE.Group.
 * Shared by all skillshot pools to avoid code duplication.
 *
 * Call AFTER scene.remove(emitter) and emitterStates.delete(emitter) so that
 * live objects are never disposed while still referenced by the renderer.
 */
export function disposeSkillshotGroup(group: THREE.Object3D): void {
  group.traverse((child) => {
    if (child.userData.preserveSharedResources === true) return;
    const mesh = child as THREE.Mesh;
    if (mesh.geometry) {
      mesh.geometry.dispose();
    }
    if (mesh.material) {
      const mats = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
      for (const m of mats) {
        (m as THREE.Material).dispose();
      }
    }
  });
}
